export default __webpack_public_path__ + "static/media/tr_2.71d273bf.mp3";